import { render, staticRenderFns } from "./shanxiTrainingInformationSupervision.vue?vue&type=template&id=1b77101f&scoped=true"
import script from "./shanxiTrainingInformationSupervision.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingInformationSupervision.vue?vue&type=script&lang=js"
import style0 from "./shanxiTrainingInformationSupervision.vue?vue&type=style&index=0&id=1b77101f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77101f",
  null
  
)

export default component.exports